export const fullNameFormatter = (data) => {
  const fullName = [data?.namePrefix, data?.firstName, data?.lastName, data?.nameSuffix]
    .filter(Boolean)
    .join(' ')
  return fullName
}

export const addressFormatter = (data) => {
  if (!data) {
    return ''
  }

  const zipFormatter = (zip) => {
    if (!zip) {
      return ''
    }
    if (zip.length === 5) {
      return zip
    }
    if (zip.length === 9) {
      return `${zip.slice(0, 5)}-${zip.slice(5)}`
    }
    return zip
  }

  const addressLine1 = data?.address1
  const addressLine2 = data?.address2
  const addressLine3 = data?.city + ', ' + data?.state + ' ' + zipFormatter(data?.zip)

  return { addressLine1, addressLine2, addressLine3 }
}
